import React from 'react';
import Colortheme from '../../Theme/Colortheme';

class BasicTextfield extends React.Component {

    constructor(props) {
        super(props);
        this.textfieldStyle = {
            background: Colortheme.textfieldBackgroundColor,
            maxWidth: props.width ?? '100%',
            lineHeight: props.height ?? '100%',
            borderRadius: '10px',
            border: `solid 2px ${Colortheme.textfieldBorderColor}`,
            color: '#000000',
            padding: '0px 10px',
            margin: props.margin,
            fontSize: 'min(calc(10px + 1.5vw), 20px)',
            flex: props.flex
        };

        this.onKeyDown = this.onKeyDown.bind(this);
    }

    onKeyDown(e) {
        const enterKey = 13
        if(e.keyCode === enterKey) {
            this.props.onSubmit()
        }
    }

    render() {
        return (
            <input type="text" style={this.textfieldStyle} placeholder={this.props.placeholder} value={this.props.value} onChange={this.props.onChange} onKeyDown={this.onKeyDown} size={5}></input>
        );
    }
}

export default BasicTextfield;